import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f265fc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Completing Your Form Online")
], -1))
const _hoisted_3 = { class: "mb-0 ml-5" }
const _hoisted_4 = { class: "ms-3" }
const _hoisted_5 = { class: "fs-4 fw-bolder" }
const _hoisted_6 = { class: "fs-6 text-dark-600 mb-lg-5 sub-con mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark mt-15" }, "MRB Privacy Notice")
], -1))
const _hoisted_8 = { class: "ms-3" }
const _hoisted_9 = { class: "fs-4 fw-bolder" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_notice = _resolveComponent("notice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guide, (guideItem, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "text-dark mb-5 d-flex guide-container"
        }, [
          _createVNode(_component_inline_svg, {
            src: '/media/icons/duotune/general/gen043.svg',
            class: "outline-icon"
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(guideItem.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(guideItem.text), 1)
          ])
        ]))
      }), 128)),
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.privacyGuide, (guideItem, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `privacy-${idx}`,
          class: "text-dark mb-5 d-flex guide-container"
        }, [
          _createVNode(_component_inline_svg, {
            src: '/media/icons/duotune/general/gen043.svg',
            class: "outline-icon"
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(guideItem.title), 1),
            _createElementVNode("div", {
              class: "fs-6 text-dark-600 mb-lg-5 sub-con mt-3",
              innerHTML: guideItem.text
            }, null, 8, _hoisted_10)
          ])
        ]))
      }), 128)),
      _createVNode(_component_notice, {
        title: "Notice",
        icon: "media/icons/duotune/general/gen044.svg",
        color: "warning",
        body: `Send comments regarding this application or any other aspect of
              this collection of information, including suggestions
              <br />
              <br />

              <b>To:</b> <br />
              SUITE A319/18 OPPOSITE NIB DANSOMAN, <br />
              GREATER ACCRA 23321, <br />
              GHANA <br />`
      })
    ])
  ]))
}